import { Action } from '@ngrx/store';
import * as models from '../../domain/models';

export const LOAD = '[RM Partner Collection] Load';
export const LOAD_SUCCESS = '[RM Partner Collection] Load Success';
export const LOAD_FAIL = '[RM Partner Collection] Load Fail';

export class LoadAction implements Action {
  readonly type = LOAD;
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: Array<models.Operator>) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction;
